export type SurgeryCaseStatus = "scheduled" | "in_progress" | "completed" | "cancelled";

export interface SurgeryCase {
  id: string;
  caseNumber: string;
  admissionId: string;
  patientId: string;
  /** Soft link — optional (SURG1). */
  consultationId?: string | null;
  /** Soft link to HospitalStay — optional (SURG2). */
  stayId?: string | null;
  procedureName: string;
  surgeonName: string;
  durationMinutes: number;
  procedureFee: number;
  operativeNotes: string;
  status: SurgeryCaseStatus;
  scheduledAt: string;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SurgeryCaseInput {
  admissionId: string;
  procedureName: string;
  surgeonName?: string;
  durationMinutes?: number;
  procedureFee?: number;
  operativeNotes?: string;
  scheduledAt?: string;
}

export interface SurgeryCaseUpdateInput {
  procedureName?: string;
  surgeonName?: string;
  durationMinutes?: number;
  procedureFee?: number;
  operativeNotes?: string;
  status?: SurgeryCaseStatus;
  scheduledAt?: string;
}

export const SURGERY_CASE_STATUS_LABELS: Record<SurgeryCaseStatus, string> = {
  scheduled: "Planifié",
  in_progress: "Au bloc",
  completed: "Terminé",
  cancelled: "Annulé",
};

export const COMMON_SURGERY_PROCEDURES = [
  "Appendicectomie",
  "Césarienne",
  "Cholécystectomie",
  "Réduction fracture",
  "Hernie inguinale",
  "Laparotomie exploratoire",
  "Autre",
] as const;
